export const TryParseInt = (str: any, defaultValue?: number | null) => {
    const val = str?.toString()

    let retValue = defaultValue
    if (val !== null) {
        if (val?.length > 0) {
            if (!isNaN(val)) {
                retValue = parseInt(val)
            }
        }
    }
    return retValue
}